import { render, staticRenderFns } from "./booking-options-sheet.vue?vue&type=template&id=b23d7d50&scoped=true&"
import script from "./booking-options-sheet.vue?vue&type=script&lang=js&"
export * from "./booking-options-sheet.vue?vue&type=script&lang=js&"
import style0 from "./booking-options-sheet.vue?vue&type=style&index=0&id=b23d7d50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23d7d50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBottomSheet,VIcon,VList,VListItem,VListItemIcon,VListItemTitle,VSheet})
